module.exports = __webpack_public_path__ + "static/media/greenDot.dc0497a9.svg";